/* The one persistent polite live region (my-work.md MA16). Content injected
   into a NON-live region is silent, and aria-busy on a freshly-inserted node
   announces nothing — so loading and its outcome are spoken from #live, which
   the shell renders once and never replaces. Peer of the vanilla
   `$(doc,"live").textContent = …`: a component announces by setting this text
   from an effect, so the accessibility tree stops asserting "Loading…" the
   moment a section answers. Safe if #live is absent (a test without the shell). */
export function announce(message: string): void {
  const el = typeof document !== "undefined" ? document.getElementById("live") : null;
  if (el) el.textContent = message;
}
